import { MAGIK_CONFIG } from "./config";

export const createClient = () => {
  const headers = {
    "X-Project-ID": MAGIK_CONFIG.projectId,
    "X-API-Key": MAGIK_CONFIG.apiKey,
    "X-SDK-Tag": MAGIK_CONFIG.sdkTag || "universal@0.1.0",
    "Content-Type": "application/json"
  };

  const post = async (path: string, body: any) => {
    const res = await fetch(`${MAGIK_CONFIG.baseUrl}${path}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body)
    });
    return res.json();
  };

  return { post };
};